import React from 'react';
import { Instagram, Facebook, Mail } from 'lucide-react';

// TikTok icon component (lucide-react doesn't have TikTok, so we create a custom one)
const TikTokIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    width="20"
    height="20"
    {...props}
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: Instagram, href: 'https://instagram.com/fmatt.photo', label: 'Instagram' },
    { icon: TikTokIcon, href: 'https://tiktok.com/@fmatt.photo', label: 'TikTok' },
    { icon: Mail, href: 'mailto:fabiomatt2005@gmail.com', label: 'E-Mail' }
  ];

  return (
    <footer className="bg-black border-t border-gray-900 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3
              className="text-2xl font-bold text-amber-400 mb-4"
              
            >
              Fabio Matt
            </h3>
            <p className="text-gray-400 text-sm">
              Hobby-Fotograf mit Leidenschaft für die schönsten Momente des Lebens durch Landschafts-, Porträt- und Sportfotografie.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Schnelllinks</h4>
            <ul className="space-y-2">
              {['Start', 'Landschaft', 'Porträt', 'Sport', 'Allgemein', 'Über mich', 'Projekte', 'Kontakt'].map((item) => {
                const href = item === 'Start' ? 'home' : item === 'Über mich' ? 'about' : item === 'Kontakt' ? 'contact' : item === 'Porträt' ? 'portrait' : item === 'Allgemein' ? 'general' : item === 'Projekte' ? 'projects' : item.toLowerCase();
                return (
                  <li key={item}>
                    <a
                      href={`#${href}`}
                      className="text-gray-400 hover:text-amber-400 transition-colors text-sm"
                    >
                      {item}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h4 className="text-white font-semibold mb-4">Folge mir</h4>
            <div className="flex space-x-4">
              {socialLinks.map((social) => {
                const Icon = social.icon;
                return (
                  <a
                    key={social.label}
                    href={social.href}
                    aria-label={social.label}
                    className="w-10 h-10 bg-gray-900 hover:bg-amber-500 rounded-lg flex items-center justify-center text-gray-400 hover:text-black transition-all duration-300"
                  >
                    <Icon size={20} />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 border-t border-gray-900 text-center">
          <p className="text-gray-500 text-sm">
            © {currentYear} Fabio Matt Fotografie. Alle Rechte vorbehalten.
          </p>
          <div className="mt-3 flex justify-center gap-6">
            <a
              href="/impressum"
              className="text-gray-500 hover:text-amber-400 transition-colors text-sm"
            >
              Impressum
            </a>
            <span className="text-gray-700">•</span>
            <a
              href="/datenschutz"
              className="text-gray-500 hover:text-amber-400 transition-colors text-sm"
            >
              Datenschutz
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;